// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PlanoMetas_IndexInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /plano_metas
 *
 * Validates query parameters for listing monthly goal plans.
 */
import { registerContract } from './validate'

export interface PlanoMetas_IndexInput {
franquia_id?: number
status?: string
ano?: string
}

registerContract('PlanoMetas_IndexInput', {
  franquia_id: { type: 'number',  required: false },
  status:      { type: 'string',  required: false },
  ano:         { type: 'string',  required: false },
})
